<template>
  <div class="card" v-if="penaltyDashboardData.rdy">
    <div class="card-header d-flex justify-content-between">
      <h6 class="mg-b-0">Төсөл салбараар</h6>
      <nav class="nav nav-row-xs align-items-center">
        <a
          @click="
            penaltyDashboardData.params.mode = 1;
            loadDashboardData();
          "
          :class="
            `nav-link ${penaltyDashboardData.params.mode == 1 ? 'active' : ''}`
          "
          role="button"
          >1D</a
        >
        <a
          @click="
            penaltyDashboardData.params.mode = 2;
            loadDashboardData();
          "
          :class="
            `nav-link ${penaltyDashboardData.params.mode == 2 ? 'active' : ''}`
          "
          role="button"
          >1W</a
        >
        <a
          @click="
            penaltyDashboardData.params.mode = 3;
            loadDashboardData();
          "
          :class="
            `nav-link ${penaltyDashboardData.params.mode == 3 ? 'active' : ''}`
          "
          role="button"
          >1M</a
        >
        <a
          @click="
            penaltyDashboardData.params.mode = 4;
            loadDashboardData();
          "
          :class="
            `nav-link ${penaltyDashboardData.params.mode == 4 ? 'active' : ''}`
          "
          role="button"
          >1Y</a
        >
        <a
          @click="
            penaltyDashboardData.params.mode = 5;
            loadDashboardData();
          "
          :class="
            `nav-link ${penaltyDashboardData.params.mode == 5 ? 'active' : ''}`
          "
          role="button"
          >ALL</a
        >
      </nav>
    </div>
    <div class="card-body">
      <apexchart
        type="treemap"
        height="350"
        :options="chartOptions"
        :series="series"
        :key="chartKey"
      ></apexchart>


      <ul id="iuasy2" class="list-group list-group-flush mg-b-0 tx-13 collapse ">
        <li
          @click="
            pnlt.show = !pnlt.show;
            reloadData();
          "
          class="list-group-item pd-x-0 d-flex justify-content-between"
          v-for="(pnlt, i) in penaltyDashboardData.data.list"
          :key="i"
          role="button"
        >
          <div class="tx-medium">
            <div
              style="float: left; margin-top: 4px; margin-right: 4px;"              :class="
                `wd-10 ht-10 ${
                  pnlt.show ? 'bg-primary' : 'bg-light'
                } rounded-circle pos-relative t--1`
              "
            ></div>
            {{ pnlt.pnltTypeTask }}
          </div>
          <span class="tx-rubik">{{ pnlt.count }}</span>
        </li>
      </ul>
    </div>
    <div class="card-footer tx-11 tx-color-03 d-flex justify-content-between">
      <div>
        Хамрах хугацаа:
        {{
          penaltyDashboardData.data.processed.startDate | moment("YYYY.MM.DD")
        }}
        -
        {{ penaltyDashboardData.data.processed.endDate | moment("YYYY.MM.DD")
        }}<br />
        Боловсруулсан:
        {{ penaltyDashboardData.data.processed.time.toFixed(2) }}сек
      </div>
      <div ><a class="btn btn-info btn-xs" data-toggle="collapse" href="#iuasy2" role="button" aria-expanded="false" aria-controls="iuasy2">Дэлгэрэнгүй</a></div>
    </div>
  </div>
</template>

<script>
// import "element-ui/lib/theme-chalk/index.css";
// import { DatePicker } from "element-ui";
import VueApexCharts from "vue-apexcharts";
// import AsyncLoadError from "@/components/base/asyncLoadingError";
// import AsyncLoading from "@/components/base/asyncLoading";

const moment = require("moment");
import { request } from "@/api/all";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      chartKey: 0,
      series: [
        {
          data: [],
        },
      ],
      chartOptions: {
        legend: {
          show: true,
        },
        chart: {
          height: 350,
          type: "treemap",
        },
        title: {
          text: "",
        },
      },
      penaltyDashboardData: {
        rdy: 0,
        params: {
          mode: 5,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        data: {
          list: [],
          processed: {
            time: 0,
            startDate: "",
            endDate: "",
          },
        },
      },
    };
  },
  mounted() {
    this.loadDashboardData();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    reloadData() {
      this.series[0].data = this.penaltyDashboardData.data.list
        .filter((x) => x.show == true)
        .map((item) => {
          return { x: item.pnltTypeTask, y: item.count };
        });
      this.chartKey++;
    },
    loadDashboardData() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "get", url: "projectedu/ProjectGroupBySalbar" },
        params: {
          mode: this.penaltyDashboardData.params.mode,
          startDate: this.penaltyDashboardData.params.startDate,
          endDate: this.penaltyDashboardData.params.endDate,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.penaltyDashboardData.data = res.data;

          this.reloadData();

          this.penaltyDashboardData.rdy = true;
          //this.vehicleCountData.processed = res.data.processed
        }
      });
    },
  },
};
</script>
